import { useContext } from 'react'
import { AuthContext } from 'src/context/auth.context'
import { ApiResponse } from 'src/domain/api'
import { StoreSCID } from 'src/slices/services/api'
import AuthenticatedApi from 'src/slices/services/authenticatedApi'
import { axiosErrorMessage } from 'src/slices/services/error'

export const useApiStoreSCID = () => {
  const authContext = useContext(AuthContext)

  const getStoreSCID = async (
    orgCode: string,
    storeCode: string
  ): Promise<ApiResponse<StoreSCID>> => {
    try {
      const token = authContext.getAuthToken()
      if (!token) {
        return {
          success: false,
          message: 'ログインしなおしてください: token is not found',
        }
      }

      const res = await new AuthenticatedApi(
        token
      ).getOrganizationsOrganizationCodeStoresStoreCodeScid(orgCode, storeCode)
      return { success: true, data: res.data }
    } catch (e: unknown) {
      const message = axiosErrorMessage(e)
      return { success: false, message }
    }
  }

  return { getStoreSCID }
}
